import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions, CommentStatus } from './index';
import { CommentCreateBody } from './create';

export type CommentUpdateData = {
  success: boolean;
};

export type CommentUpdateResponse = CommentUpdateData;

export interface CommentUpdateBody extends Partial<CommentCreateBody> {
  status?: CommentStatus;
}

export interface CommentUpdatePayload {
  id: string;
  body: CommentUpdateBody
}

export const commentUpdate = (payload: CommentUpdatePayload): Action<CommentUpdatePayload> => ({
  type: actions.commentUpdateTrigger.toString(),
  payload,
});

export const commentUpdateClear = (): Action => ({
  type: actions.commentUpdateClear.toString(),
});

export const commentUpdateErrorClear = (): Action => ({
  type: actions.commentUpdateErrorReset.toString(),
});

export function* commentUpdateRequestSaga({ payload }: Action<CommentUpdatePayload>) {
  yield put({
    type: actions.commentUpdateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.commentUpdateError.toString(),
      payload: {
        message: 'CommentUpdate: Parameters not passed.',
      },
    });

    return;
  }

  const { id, body } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}comments/${id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<CommentUpdateData, CommentUpdateResponse>(
    response,
    actions.commentUpdateSuccess.toString(),
    actions.commentUpdateError.toString(),
    false,
    (commentUpdateData) => commentUpdateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.commentUpdateTrigger.toString(),
    defaultProcessingSaga(
      commentUpdateRequestSaga,
      {
        error: actions.commentUpdateError.toString(),
        locationCancel: actions.commentUpdateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.commentUpdateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.commentUpdateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.commentUpdateErrorReset.toString(),
    });
  });
}
